import React from 'react';
import './ProjectHeader.scss';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { Field } from 'Components/Core/Field';
import { TextOutput } from 'Components/Core';
import { useSelector } from 'react-redux';

let ProjectHeader: React.FC = () => {
  const header = useSelector((state) => state.agsProjectExport.projectDetails);

  return (
    <>
      {!window.qest.isFrame && (
        <header className="ProjectHeader">
          <section className="ProjectHeader-Headings">
            <span className="ProjectHeader-Heading ProjectHeader-Heading-smallHide">
              AGS Data for {header.projectCode}
            </span>
            <div className="ProjectHeader-Heading ProjectHeader-Heading-largeHide">
              <span>{header.projectCode}</span>
            </div>
          </section>
          <div className="ProjectHeader-Fields">
            <ListFieldSection>
              <Field input={<TextOutput />} label="Project" value={header.projectName} />
              <Field input={<TextOutput />} label="Client" value={header.clientName} />
            </ListFieldSection>
          </div>
        </header>
      )}
    </>
  );
};

ProjectHeader = withInjectedProps(ProjectHeader);

export { ProjectHeader };
export default ProjectHeader;
